import ApiClient from './ApiClient';

export default class LanguageApi {
  constructor(apiClient) {
    this.apiClient = apiClient || ApiClient.instance;
  }

  getLanguages() {
    return this.apiClient.get({ path: '/api/i18n/languages' });
  }

  insertLanguage(body) {
    return this.apiClient.post({ path: '/api/i18n/languages', body });
  }

  updateLanguage(languageId, body) {
    // verify the required parameter 'languageId' is set
    if (languageId === undefined || languageId === null) {
      throw new Error("Missing the required parameter 'languageId' when calling updateLanguage");
    }
    return this.apiClient.put({ path: `/api/i18n/languages/${languageId}`, body });
  }
}
